import dayjs from "dayjs";
import { formatCost } from "@/helpers/utils";

export type Granularity = "day" | "week" | "month";

export const formatChartDate = (value: string, granularity: Granularity): string => {
  const d = dayjs(value);
  if (!d.isValid()) return value;
  if (granularity === "month") return d.format("MMM YYYY");
  return d.format("MMM DD");
};

export const formatChartCurrency = (value: string | number, currency = "USD"): string => {
  const n = typeof value === "string" ? parseFloat(value) : value;
  if (Number.isNaN(n)) return String(value);
  return formatCost(n, currency);
};
